import { render, staticRenderFns } from "./StepMessage.vue?vue&type=template&id=082302a5&"
import script from "./StepMessage.vue?vue&type=script&lang=js&"
export * from "./StepMessage.vue?vue&type=script&lang=js&"
import style0 from "./StepMessage.vue?vue&type=style&index=0&id=082302a5&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports